import { isAxiosError } from 'axios';
import type { ApiError } from '@/types';

/**
 * Normalizes any thrown error (Axios error, network error, or unknown) into
 * a single human-readable message. Every mutation hook's onError should
 * route through this so error copy stays consistent app-wide.
 */
export function getApiErrorMessage(error: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (isAxiosError<ApiError>(error)) {
    return error.response?.data?.message ?? fallback;
  }
  if (error instanceof Error) {
    return error.message || fallback;
  }
  return fallback;
}
